import { ILossPreventionConfig } from '../useLossPreventionConfig'

export const ghaiPopConfig: ILossPreventionConfig = {
  summary: {
    isVisible: true,
  },
  kpiSettings: [
    { category: 'basic', key: 'totalComps', title: 'Total Discounts' },
    { category: 'basic', key: 'cashOverOrShort', title: 'Cash +/-' },
    {
      category: 'custom',
      type: 'Voids',
      title: 'Voids',
      key: 'amount',
    },
    {
      category: 'custom',
      type: 'Voids',
      title: '% Checks with Voids',
      key: 'checkPercent',
    },
    {
      category: 'custom',
      type: 'Cash Refund',
      title: 'Cash Refund',
      key: 'amount',
    },
    {
      category: 'custom',
      type: 'Non-Cash Refund',
      title: 'Non-Cash Refund',
      key: 'amount',
    },
  ],
  discountByEmployeeTable: {
    display: false,
  },
  cashHandlingTable: {
    display: false,
    columns: [],
  },
  voidsAndDeletesTable: {
    display: false,
    columns: [],
  },
  opsCompsBreakdownTable: {
    display: true,
  },
}
